export default "__VITE_ASSET__9846d2bd__"